import * as yup from 'yup'

export default yup.object().shape({
  payment_option: yup.string().required('Selecione a Forma de Pagamento')
})
